import template from './indexing-delay-alert.jade';

export default () => {
  return {
    template,
    scope: {},
    bindToController: {},
    controller: ['config', 'deviceService', function(config, deviceService) {
      this.isMobile = deviceService.isMobile;

      this.title = config.get('addForm.indexingDelayAlert.title');
      this.body = config.get('addForm.indexingDelayAlert.body');
    }],
    controllerAs: 'indexingDelayAlertCtrl',
    replace: true,
  };
};
